module.exports = __webpack_public_path__ + "img/ASM.56fd7c87.svg";